export const decrementBagCount = () => {
  window.stitchfix = window.stitchfix || {};
  if (typeof window.stitchfix.decrementBagCount === 'function') {
    // This is defined in knit.
    window.stitchfix.decrementBagCount();
  }
};

export const incrementBagCount = () => {
  window.stitchfix = window.stitchfix || {};
  if (typeof window.stitchfix.incrementBagCount === 'function') {
    // This is defined in knit.
    window.stitchfix.incrementBagCount();
  }
};
